import apiClient from './client';

// Use centralized API client as 'api' for consistency
const api = apiClient;

/**
 * Get all expense categories
 * @param {Object} params - Query parameters
 * @returns {Promise} API response
 */
export const getExpenseCategories = async (params = {}) => {
  const response = await api.get('/expense-categories', { params });
  return response.data;
};

/**
 * Get a single expense category by ID
 * @param {number} id - Category ID
 * @returns {Promise} API response
 */
export const getExpenseCategory = async (id) => {
  const response = await api.get(`/expense-categories/${id}`);
  return response.data;
};

/**
 * Create a new expense category
 * @param {Object} categoryData - Category data
 * @returns {Promise} API response
 */
export const createExpenseCategory = async (categoryData) => {
  const response = await api.post('/expense-categories', categoryData);
  return response.data;
};

/**
 * Update an expense category
 * @param {number} id - Category ID
 * @param {Object} categoryData - Updated category data
 * @returns {Promise} API response
 */
export const updateExpenseCategory = async (id, categoryData) => {
  const response = await api.put(`/expense-categories/${id}`, categoryData);
  return response.data;
};

/**
 * Delete an expense category
 * @param {number} id - Category ID
 * @returns {Promise} API response
 */
export const deleteExpenseCategory = async (id) => {
  const response = await api.delete(`/expense-categories/${id}`);
  return response.data;
};

/**
 * Get expense category summary/statistics
 * @param {Object} params - Query parameters (start_date, end_date)
 * @returns {Promise} API response
 */
export const getExpenseCategorySummary = async (params = {}) => {
  const response = await api.get('/expense-categories/summary/statistics', { params });
  return response.data;
};

export default {
  getExpenseCategories,
  getExpenseCategory,
  createExpenseCategory,
  updateExpenseCategory,
  deleteExpenseCategory,
  getExpenseCategorySummary
};
